/**
 * Runtime services config — sourced from Vite's native `.env.<mode>`
 * loading. Keys are individually declared as `VITE_*` env vars (see
 * `src/vite-env.d.ts` for the typed shape)
 */
export const SERVICES_ENV: Readonly<{
  AWS_COGNITO_USER_POOL_CLIENT_ID: string;
  AWS_COGNITO_USER_POOL_ID: string;
  AWS_COGNITO_USER_POOL_MOBILE_CLIENT_ID: string;
  AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: string;
  AWS_REGION: string;
  PT_API_ENDPOINT: string;
  PT_BO_ENDPOINT: string;
  PT_MARKETING_ENDPOINT: string;
  PT_WEB_ENDPOINT: string;
  PT_WEB2_ENDPOINT: string;
  PT_WEB_VERIFY_ENDPOINT: string;
  GTM_AUTH: string;
  GTM_ID: string;
  GTM_PREVIEW: string;
  ONESIGNAL_APP_ID: string;
  META_PIXEL_ID?: string;
  // Intercom Messenger workspace App ID (public — not a secret). Read from env
  // config; optional so an env without it simply disables the widget.
  INTERCOM_APP_ID?: string;
}> = {
  AWS_COGNITO_USER_POOL_CLIENT_ID: import.meta.env.VITE_AWS_COGNITO_USER_POOL_CLIENT_ID,
  AWS_COGNITO_USER_POOL_ID: import.meta.env.VITE_AWS_COGNITO_USER_POOL_ID,
  AWS_COGNITO_USER_POOL_MOBILE_CLIENT_ID: import.meta.env.VITE_AWS_COGNITO_USER_POOL_MOBILE_CLIENT_ID,
  AWS_COGNITO_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_AWS_COGNITO_USER_POOL_WEB_CLIENT_ID,
  AWS_REGION: import.meta.env.VITE_AWS_REGION,
  PT_API_ENDPOINT: import.meta.env.VITE_PT_API_ENDPOINT,
  PT_BO_ENDPOINT: import.meta.env.VITE_PT_BO_ENDPOINT,
  PT_MARKETING_ENDPOINT: import.meta.env.VITE_PT_MARKETING_ENDPOINT,
  PT_WEB_ENDPOINT: import.meta.env.VITE_PT_WEB_ENDPOINT,
  PT_WEB2_ENDPOINT: import.meta.env.VITE_PT_WEB2_ENDPOINT,
  PT_WEB_VERIFY_ENDPOINT: import.meta.env.VITE_PT_WEB_VERIFY_ENDPOINT,
  GTM_AUTH: import.meta.env.VITE_GTM_AUTH,
  GTM_ID: import.meta.env.VITE_GTM_ID,
  GTM_PREVIEW: import.meta.env.VITE_GTM_PREVIEW,
  ONESIGNAL_APP_ID: import.meta.env.VITE_ONESIGNAL_APP_ID,
  META_PIXEL_ID: import.meta.env.VITE_META_PIXEL_ID,
  INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,
};

export const GIPHY_API_KEY = import.meta.env.GIPHY_API_KEY as string;
